<div
  *ngIf="options"
  class="template-preview non-fullscreen flex-column"
  [class.preview-disabled]="!!disabledInfo"
  [ngbTooltip]="disabledInfo?.tooltipText ? (disabledInfo.tooltipText | transloco) : ''">
  <div *ngIf="previewIcon" class="content-icon">
    <i class="{{ previewIcon }}"></i>
  </div>

  <div class="title-container content-title item-title">
    <span *ngIf="title" class="template-title">{{ title }}</span>
  </div>

  <div class="template-preview__content-wrapper">
    <lib-cfs-template-preview
      class="template-preview__content {{ screenSize }}"
      [class.calc-aspect-ratio]="calcAspectRatio"
      [animationType]="TemplateAnimationType.Static"
      [screenSize]="screenSize"
      [options]="options">
    </lib-cfs-template-preview>
  </div>
</div>
